import React from 'react';
import { Box, Typography, Container, useMediaQuery, useTheme } from '@mui/material';
import ProjectPartners from './ProjectPartners';
import { Link } from 'react-router-dom';

const Footer = () => {
    const primaryBlue = '#1F1B9E';
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box>
            {/* White section for Projektpartner and logos */}
            <Box sx={{
                bgcolor: 'white',
                py: { xs: 2, sm: 3 },
                borderTop: `4px solid ${primaryBlue}`
            }}>
                <Container>
                    <Typography
                        variant="h6"
                        sx={{
                            color: primaryBlue,
                            mb: { xs: 1, sm: 2 },
                            textAlign: 'center',
                            fontSize: { xs: '1.2rem', sm: '1.5rem' }
                        }}
                    >
                        Projektpartner
                    </Typography>
                    <ProjectPartners />
                </Container>
            </Box>

            {/* Blue section for links */}
            <Box
                sx={{
                    bgcolor: primaryBlue,
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: { xs: '100px', sm: '150px' }
                }}
            >
                <Container>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: { xs: 3, sm: 7 },
                        py: { xs: 2, sm: 4 },
                        flexWrap: 'wrap'
                    }}>
                        <Typography
                            component="a"
                            href="https://www.campus02.at/impressum/"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                color: 'white',
                                textDecoration: 'none',
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                '&:hover': {
                                    textDecoration: 'underline'
                                }
                            }}
                        >
                            Impressum
                        </Typography>
                        <Typography
                            component={Link}
                            to="/Datenschutzerklaerung"
                            sx={{
                                color: 'white',
                                textDecoration: 'none',
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                '&:hover': {
                                    textDecoration: 'underline'
                                }
                            }}
                        >
                            Datenschutzerklärung
                        </Typography>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};

export default Footer;